module.exports = __webpack_public_path__ + "img/back-icon.13dff54b.svg";